<template>
    <div>
        
        <div v-show="isZC">
            <el-row :gutter="20"  style="margin-top:30px;">                            
                <el-col :span="24">
                    <el-row  :gutter="20" class="mgb20">
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-01">
                                    <i class="el-icon-message-solid grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{stat.jjcljh}}</div>
                                        <div>紧急处理计划</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-02">
                                    <i class="el-icon-s-flag grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{stat.dcljh}}</div>
                                        <div>待处理计划</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-03">
                                    <i class="el-icon-s-ticket grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{stat.zjhs}}</div>
                                        <div>总计划数</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row  :gutter="20" class="mgb20">
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-01">
                                    <i class="el-icon-document grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{stat.dqyxddl}}</div>
                                        <div>当前有效订单量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-02">
                                    <i class="el-icon-document-copy grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{stat.zddl}}</div>
                                        <div>总订单量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-03">
                                    <i class="el-icon-user-solid grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{stat.fwkhs}}</div>
                                        <div>服务客户数</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                   
                </el-col>               
                
                <!-- <el-col :span="9"  v-if="AnalysisTitle.dt1[0]">
                    <el-card shadow="hover" class="mgb20" style="height:252px;">
                        <div class="user-info">
                            <img src="../../images/微信图片_20200925103004.png" class="user-avator" alt />
                            <div class="user-info-cont">
                                <div class="user-info-name">{{ AnalysisTitle.dt1[0].uName }}</div>
                            </div>
                        </div>
                        <div class="user-info-list">
                            上次登录时间：
                            <span>{{AnalysisTitle.dt1[0].loginTime}}</span>
                        </div>
                    </el-card>
                   
                </el-col> -->
            </el-row>

            <div style="display:flex;justify-content:center;margin-top:30px;width:100%;">
                <div id="weekChart_ZC" :style="[{width:chartWidth},{height:'400px'}]"></div>

                <!-- style="width:1000px;height: 400px; padding-top:10px; -->
            </div>
            <!-- <el-row>
                <el-col :span="12">
                    <div id="analisysCate1" style="width:600px;height: 400px;padding-top:10px;"></div>
                </el-col>
                <el-col :span="12">
                    <div id="analisysCate2" style="width:600px;height: 400px;padding-top:10px;"></div>
                </el-col>
            </el-row> -->

            <!-- <el-row>
                <span>紧急任务列表</span>
                <el-link @click="gotoMoreUrgent" style="margin-left:50px;" type="primary">more ...</el-link>
                <el-table 
                :data="indexUrgentList" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="订单编号" align="center" sortable width="130" label="订单编号">
                </el-table-column>
                <el-table-column prop="终端客户" align="center" sortable  label="终端客户" ></el-table-column>
                <el-table-column prop="产品名称" align="center" sortable label="产品名称" ></el-table-column>
                <el-table-column prop="数量" align="center" sortable width="60" label="数量" ></el-table-column>
                <el-table-column prop="跟进日期" align="center" width="200" label="跟进日期" >
                    <template slot-scope="scope" >
                        {{scope.row.planSDate.split('T')[0]}} 至  {{scope.row.planEDate.split('T')[0]}}
                    </template>
                </el-table-column> 
                <el-table-column prop="topic" align="center" sortable width="170" label="任务主题" ></el-table-column>
                <el-table-column prop="订单状态" align="center" sortable width="80" label="订单状态" ></el-table-column>
                <el-table-column prop="执行状态" align="center" sortable width="110" label="执行状态" >
                    <template slot-scope="scope" >
                        <span :style="scope.row.执行状态=='超期未执行'?'color:red;':
                            scope.row.执行状态=='执行期(未执行)'?'color:yellow':
                            scope.row.执行状态=='待执行'?'':'color:gray'">
                            {{scope.row.执行状态=='超期未执行' || scope.row.执行状态=='超期执行'?'***'+scope.row.执行状态:scope.row.执行状态}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rowTime" align="center" sortable width="160" label="创建时间" ></el-table-column>
                <el-table-column align="center" width="140" label="编辑" >
                    <template slot-scope="scope" >
                        <el-button type="text" @click="onDoClick(scope.row)">跟进</el-button>
                    </template>
                </el-table-column>

                 
                </el-table>
            </el-row>
            
            <el-dialog title="计划跟进" :visible="doDialogVisible" width="60%"
                                :modal-append-to-body='false'
                                :close-on-click-modal='false'
                                @close="doDialogVisible = false" 
                                append-to-body>
                    <el-form :model="doForm" inline >
                        <el-row>
                            <el-form-item label="服务时间">
                                <el-date-picker
                                    v-model="doForm.dealDate"
                                    type="datetime"
                                    placeholder="选择服务时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="服务内容">
                                <el-input v-model="doForm.content" size="medium" :rows="8" type="textarea"
                                    autocomplete="off" placeholder="请填写服务内容" style="width:800px"
                                    ></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <my-upload-file-form-item v-model="doForm.sampleArr" label="附件" :limit="10" />
                        </el-row>                  
                    </el-form>      
                    <div  style="display:flex;justify-content:center;margin-top:20px;">
                        <el-button @click="doDialogVisible = false">关闭</el-button>
                        <el-button style="margin-left:20px;" type="primary" @click="onSaveDo">保存</el-button>
                    </div> 
                    <el-divider content-position="center">Tips</el-divider>
                    <div>
                        <span>
                            <p style="margin-left:20px;" v-if="curItem.remark" v-html="curItem.remark.replace('\r\n','\n').split('\n').map(item => `<p>${item}</p>`).join('')"></p>
                        </span>
                    </div>

                    <el-divider content-position="center">跟进历史</el-divider>
                    <el-timeline >
                        <el-timeline-item v-for="(activity, index) in doLog" :key="index" :timestamp="activity.dealDate">
                            <p style="margin-left:20px;" v-if="activity.dealContent" v-html="activity.dealContent.replace('\r\n','\n').split('\n').map(item => `<p>${item}</p>`).join('')"></p>
                            <div style="display:flex" v-for="(sample, indexs) in activity.sampleArr" :key="indexs">
                                <el-link type="primary" :href="sample.url" target="_blank">{{sample.name}}</el-link>
                            </div>
                        </el-timeline-item>
                    </el-timeline>                
                </el-dialog> -->

        </div>
        <div v-show="!isZC">
            <el-row v-if="AnalysisTitle.dt1" :gutter="20">
                <el-col :span="12">
                    <el-card shadow="hover" class="mgb20" style="">
                        <div class="user-info">
                            <img src="../../images/微信图片_20200925103004.png" class="user-avator" alt />
                            <div class="user-info-cont">
                                <div class="user-info-name">{{ AnalysisTitle.dt1[0].uName }}</div>
                                <!-- <div>{{ role }}</div> -->
                            </div>
                        </div>
                        <div class="user-info-list" style="display:flex;flex-wrap:wrap;">
                            <div>上次登录时间：</div>
                            <div>{{AnalysisTitle.dt1[0].loginTime}}</div>
                            
                        </div>
                        <!-- <div class="user-info-list">
                            上次登录地点：
                            <span>东莞</span>
                        </div> -->
                    </el-card>
                    <el-card v-if="AnalysisTitle.dt1[0].isAdmin" shadow="hover" style="height:252px;">
                        <template #header>
                            <div class="clearfix">
                                <span>工单类型</span>
                            </div>
                        </template>
                        <div v-for="(item, index) in AnalysisTitle.dt2" :key="index" >
                            {{item.dictValue}}
                            <el-progress :percentage="item.rate" color="#42b983"></el-progress>
                        </div>
                        <!-- 账单对账
                        <el-progress :percentage="71.3" color="#42b983"></el-progress>奖励政策
                        <el-progress :percentage="24.1" color="#f1e05a"></el-progress>下单操作
                        <el-progress :percentage="13.7"></el-progress>产品价格
                        <el-progress :percentage="5.9" color="#f56c6c"></el-progress> -->
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-row  v-if="AnalysisTitle.dt1[0].isAdmin" :gutter="20" class="mgb20">
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-1">
                                    <i class="el-icon-user-solid grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{AnalysisTitle.dt1[0].totalCnt}}</div>
                                        <div>累计工单量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-2">
                                    <i class="el-icon-message-solid grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{AnalysisTitle.dt1[0].monthCnt}}</div>
                                        <div>当月工单量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                <div class="grid-content grid-con-3">
                                    <i class="el-icon-s-goods grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{AnalysisTitle.dt1[0].avgDay}}</div>
                                        <div>当月平均处理用时（小时）</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-card shadow="hover" style="height:403px;">
                        <template #header>
                            <div class="clearfix">
                                <span>待处理工单</span>
                                <el-link @click="gotoMore" style="margin-left:50px;" type="primary">more ...</el-link>
                                
                                <!-- <el-button style="float: right; padding: 3px 0" type="text">添加</el-button> -->
                            </div>
                        </template>
                        <div v-if="isMobile">
                            <div v-for="(item,index) in AnalysisTitle.dt3" :key="index">
                                <el-row>
                                    <el-col :span="21">{{ item.title.length>10?item.title.substring(1,10)+'...':item.title }}</el-col>
                                    <el-col :span="3"><el-tooltip class="item" effect="dark" content="跟进" >
                                            <i class="el-icon-edit"  @click="onItemEditClick(item)"></i>
                                        </el-tooltip></el-col>
                                </el-row>
                            </div>
                        </div>
                        <div v-else>
                            <el-table :show-header="false" :size-pre-page="5" :data="AnalysisTitle.dt3" style="width:100%;">
                                <!-- <el-table-column width="40">
                                    <template #default="scope">
                                        <el-checkbox v-model="scope.row.status"></el-checkbox>
                                    </template>
                                </el-table-column> -->
                                <el-table-column>
                                    <template #default="scope">
                                        <div
                                            class="todo-item"
                                            :class="{
                                                'todo-item-del': true,
                                            }"
                                        >{{ scope.row.title }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="80">
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="small"
                                                @click.native.prevent="onItemEditClick(scope.row)"
                                            >跟进</el-button>
                                        <!-- <el-tooltip class="item" effect="dark" content="跟进" >
                                            <i class="el-icon-edit"  @click.native.prevent="onItemEditClick(scope.row)"></i>
                                        </el-tooltip> -->
                                        <!-- <i class="el-icon-edit">跟进</i> -->
                                        <!-- <i class="el-icon-delete"></i> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row  v-if="AnalysisTitle.dt1 && AnalysisTitle.dt1[0].isAdmin" :gutter="20">
                <el-col :span="12">
                    <el-card shadow="hover">
                        <!-- <schart ref="bar" class="schart" canvasId="bar" :options="options"></schart> -->
                        <div id="weekChart" style="height: 400px;padding-top:10px;"></div>
                        <!-- <source-chart v-for="(viewItem,index) in weekAnalysis" :key="index"
                            :x-axis-data="viewItem.map(item=>item.xAxisName)"
                            :y-axis-data="viewItem.map(item=>item.cnt)"
                            :title="viewItem[0].title"
                        ></source-chart> -->
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card shadow="hover">
                        <!-- <schart ref="line" class="schart" canvasId="line" :options="options2"></schart> -->
                        <div id="monthChart" style="height: 400px;padding-top:10px;"></div>
                        <!-- <source-chart v-for="(viewItem,index) in monthAnalysis" :key="index"
                            :x-axis-data="viewItem.map(item=>item.xAxisName)"
                            :y-axis-data="viewItem.map(item=>item.cnt)"
                            :title="viewItem[0].title"
                        ></source-chart> -->
                    </el-card>
                </el-col>
            </el-row>
            <el-row  v-if="AnalysisTitle.dt1 && AnalysisTitle.dt1[0].isAdmin" :gutter="20">
                <el-col :span="24">
                    <el-card shadow="hover">
                        <div id="dayChart" style="height: 400px;padding-top:10px;"></div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
// import Schart from "vue-schart";
import SourceChart from "@/views/Index/SourceChart";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {getSampleArrayFromSever,getSampleLogStrToSever} from "@/utils/tools";
import {encrypt} from "@/utils/encrypt";
import {
		showWeekChart,
		showMonthChart,	
        showDayChart,	
        showWeekChart_ZC,
        indexCate,
} from "@/views/Index/utils";
import {ZC_SaveResult} from "@/api/zc";


export default {
    name: "dashboard",
    data() {
        return {
            // name: localStorage.getItem("ms_username"),
            todoList: [
                {
                    title: "测试任务1",
                    status: false
                },
                {
                    title: "测试任务2",
                    status: false
                },
                {
                    title: "测试任务3",
                    status: false
                },
                {
                    title: "测试任务4",
                    status: false
                },
                {
                    title: "测试任务5",
                    status: true
                },
                {
                    title: "测试任务6",
                    status: true
                }
            ],
            data: [
                {
                    name: "2018/09/04",
                    value: 1083
                },
                {
                    name: "2018/09/05",
                    value: 941
                },
                {
                    name: "2018/09/06",
                    value: 1139
                },
                {
                    name: "2018/09/07",
                    value: 816
                },
                {
                    name: "2018/09/08",
                    value: 327
                },
                {
                    name: "2018/09/09",
                    value: 228
                },
                {
                    name: "2018/09/10",
                    value: 1065
                }
            ],
            options: {
                type: "bar",
                title: {
                    text: "最近一周各类工单占比"
                },
                xRorate: 25,
                labels: ["周一", "周二", "周三", "周四", "周五"],
                datasets: [
                    {
                        label: "账单对账",
                        data: [7, 27, 20, 19, 23]
                    },
                    {
                        label: "奖励政策",
                        data: [6, 18, 10, 13, 16]
                    },
                    {
                        label: "下单操作",
                        data: [14, 19, 15, 23, 10]
                    },
                    {
                        label: "产品价格",
                        data: [3, 3, 7, 22, 12]
                    }
                ]
            },
            options2: {
                type: "line",
                title: {
                    text: "月度工单处理趋势图"
                },
                labels: ["6月", "7月", "8月", "9月", "10月"],
                datasets: [
                    {
                        label: "账单对账",
                        data: [234, 278, 270, 190, 230]
                    },
                    {
                        label: "奖励政策",
                        data: [164, 178, 150, 135, 160]
                    },
                    {
                        label: "下单操作",
                        data: [74, 118, 200, 235, 90]
                    }
                    ,
                    {
                        label: "产品价格",
                        data: [114, 108, 170, 205, 190]
                    }
                ]
            },
            
            
            //筑巢
            isZC:false,
            curItem:{},
            doLog:[],
            doForm:{
                dealDate:'',
                content:'',
                sampleArr:[],
            },
            doDialogVisible:false,
            stat:{
                jjcljh:0,
                dcljh:0,
                zjhs:0,
                dqyxddl:0,
                zddl:0,
                fwkhs:0
            },
            chartWidth: window.innerWidth + 'px',
        };
    },
    components: {
        // Schart
        SourceChart,MyUploadFileFormItem
    },
    computed: {
        // role() {
        //     return this.name === "admin" ? "超级管理员" : "普通用户";
        // }
		...mapGetters(['AnalysisTitle','indexStatValueList','indexUrgentList','resultList','weekDoneList','analisysCate1','analisysCate2','isMobile']),
    },
    async mounted(){
        var systemTitle = localStorage.getItem('systemTitle');
        this.$store.dispatch("setting/checkDevice");
        await this.$store.dispatch('index/AnalysisTitle');	
        if (systemTitle=='筑巢计划CRM管理系统'){
            this.queryZCData().then(()=>{
                this.isZC=true;
                // console.log('data11111',document.getElementById('weekChart_ZC'))
                if (document.readyState === "complete") {
                // var g1Json = JSON.parse(this.AnalysisTitle.g1.replace(/\'/g,"\""));
                // console.log('aaaaa',this.weekDoneList)
                    showWeekChart_ZC(this.weekDoneList);
                    // indexCate('analisysCate1',this.analisysCate1);
                    // indexCate('analisysCate2',this.analisysCate2);
                }
            })
            
            // var mainChart = document.getElementById('weekChart_ZC')
            
        }
        else{
            // console.log('bbb')
            
            // console.log('AnalysisTitle',this.AnalysisTitle.g1);
            var g1Json = JSON.parse(this.AnalysisTitle.g1.replace(/\'/g,"\""));
            var g2Json = JSON.parse(this.AnalysisTitle.g2.replace(/\'/g,"\""));
            var g3Json = JSON.parse(this.AnalysisTitle.g3.replace(/\'/g,"\""));
            // console.log('g3Json',g3Json);
            showWeekChart(g1Json);
            showMonthChart(g2Json);
            showDayChart(g3Json);
        }
    },

    methods: {

        async queryZCData(){
            await this.$store.dispatch('zc/ZC_Index',{}).then(()=>{
                // console.log('aaa',this.indexStatValueList)
                this.stat= this.indexStatValueList[0];
                
                
            })	
        },

        async onDoClick(item){
            this.curItem=item;
            this.doLog=[];
            this.doForm.content='';
            this.doForm.dealDate='';
            this.doForm.sampleArr=[];
            await this.$store.dispatch('zc/resultList',{planId:item.id}).then(()=>{
                this.resultList.forEach(ele=>{
                    var obj={};
                    var samples = ele.samples;
                    obj=ele;
                    obj.sampleArr=getSampleArrayFromSever({samples});
                    this.doLog.push(obj);
                })
                this.doDialogVisible=true;
            });             
        },

        async onSaveDo(){
            const {dealDate,content,sampleArr} = this.doForm;
            if (!dealDate){
                this.$message.warning('选择服务时间')
                return;
            }
            if (!content){
                this.$message.warning('请填写服务内容')
                return;
            }

            var samples = getSampleLogStrToSever({sampleArr})
            // console.log('aa',sampleArr,samples)   id,planId,dealDate,dealContent,samples
            await ZC_SaveResult({id:'',planId:this.curItem.id,dealDate,dealContent:content,samples});
            this.$message.success('保存成功');
            // this.onQuery();
            this.queryZCData();
            this.doDialogVisible=false;

        },

        // changeDate() {
        //     const now = new Date().getTime();
        //     this.data.forEach((item, index) => {
        //         const date = new Date(now - (6 - index) * 86400000);
        //         item.name = `${date.getFullYear()}/${date.getMonth() +
        //             1}/${date.getDate()}`;
        //     });
        // }
        async onItemEditClick(item) {
            
            this.$router.push({name: 'SheetViewParent', params: {Id: encrypt(item.id)}});
        },

        gotoMore(){
            // this.$router.push({name: '/WorkSheet/Index/2', params: {menuModuleId: 2}});
            this.$router.push({name: 'WorkSheet', params: {menuModuleId: 2}});
        },

        gotoMoreUrgent(){
            this.$router.push({name: 'Todo'});
        }
    }
};
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 2.2rem;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-01 .grid-con-icon {
    background:#6887c2;
}

.grid-con-01 .grid-num {
    color:#6887c2;
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-02 .grid-con-icon {
    background:#3A68BC;
}

.grid-con-02 .grid-num {
    color: #3A68BC;
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}

.grid-con-03 .grid-con-icon {
    background: #6A8ED0;
}

.grid-con-03 .grid-num {
    color: #6A8ED0;
}

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.user-avator {
    width: 120px;
    /* height: 120px; */
    border-radius: 50%;
}



.user-info-cont div:first-child {
    font-size: 2.2rem;
    color: #222;
}



.mgb20 {
    margin-bottom: 20px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    /* text-decoration: line-through; */
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}

.el-card{
    border: 0px 1px solid #e6ebf5;
}
</style>
